import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow: auto;
  flex-wrap: nowrap;
  padding: 0 var(--cms-grid-column-gap, 0.266rem);
  gap: var(--cms-grid-row-gap, 0.266rem) var(--cms-grid-column-gap, 0.266rem);
  > div {
    flex: 0 0 auto;
  }
`

export const ColWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 4rem;
  gap: var(--cms-grid-row-gap) var(--cms-grid-column-gap);
  flex-wrap: nowrap;
`
